import { Routes } from '@angular/router';
import { DialogPage } from './dialog-page/dialog-page';
import { ExpressionPage } from './expression-page';
import { ExpressiveReadingPage } from './expressive-reading-page/expressive-reading-page';

export const mechanicExpressionRoutes: Routes = [
  {
    path: '',
    component: ExpressionPage,
  },
  {
    path: 'dialog',
    component: DialogPage,
  },
  {
    path: 'expressive-reading',
    component: ExpressiveReadingPage,
  },
];
